<p-confirmDialog></p-confirmDialog>

<div class="plan-page-container">
  <div class="plan-page-header">
    <h3 class="m-0">RAID</h3>
    <p-button label="Add" icon="pi pi-plus" (onClick)="showAddItemDialog()" severity="info" [rounded]="true" />
  </div>

  <p-table
    [scrollable]="true"
    scrollHeight="flex"
    [value]="items"
    [loading]="loading"
    [paginator]="items.length > 10"
    [rows]="10"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[10, 20, 50]"
    [tableStyle]="{ 'min-width': '100%' }"
    styleClass="p-datatable no-column-lines compact-striped-table table-scroll-both presales-raid-table">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 80px;">#</th>
        <th style="width: 110px;">Type</th>
        <th>Description</th>
        <th style="width: 120px;">Identified</th>
        <th style="width: 100px;">Impact</th>
        <th style="width: 150px;">Owner</th>
        <th style="width: 120px;">Target</th>
        <th style="width: 100px;">Status</th>
        <th>Mitigation</th>
        <th style="width: 120px;">Closed</th>
        <th class="th-actions" style="width: 100px;">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ item.itemNumber }}</td>
        <td>{{ item.type }}</td>
        <td class="td-truncate" [pTooltip]="item.description || '-'" tooltipPosition="top">{{ item.description || '-' }}</td>
        <td>{{ formatDate(item.identifiedDate) }}</td>
        <td>
          <p-tag [value]="item.impact" [severity]="getImpactSeverity(item.impact)" style="font-size: 0.7rem;" />
        </td>
        <td>{{ item.owner }}</td>
        <td>{{ formatDate(item.targetDate) }}</td>
        <td>
          <p-tag [value]="item.status" [severity]="getStatusSeverity(item.status)" style="font-size: 0.7rem;" />
        </td>
        <td class="td-truncate" [pTooltip]="item.mitigationPlan || '-'" tooltipPosition="top">{{ item.mitigationPlan || '-' }}</td>
        <td>{{ formatDate(item.dateClosed) }}</td>
        <td class="table-cell-actions">
          <div class="table-actions-stack">
            <p-button icon="pi pi-pencil" [text]="true" size="small" severity="info"
              (onClick)="showEditItemDialog(item)" pTooltip="Edit" tooltipPosition="top" />
            <p-button icon="pi pi-trash" [text]="true" size="small" severity="danger"
              (onClick)="confirmDelete(item)" pTooltip="Delete" tooltipPosition="top" />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="11" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No RAID items found</p>
            <p class="empty-description">Click "Add" to log a risk, assumption, issue, or dependency.</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Item Dialog -->
<p-dialog
  [visible]="displayItemDialog"
  (visibleChange)="displayItemDialog = $event"
  [header]="isEditItemMode ? 'Edit RAID Item' : 'Add RAID Item'"
  [modal]="true"
  [style]="{width: '95vw', maxWidth: '1000px'}"
  appendTo="body"
  [dismissableMask]="false"
  [closable]="!saveInFlight">

  <div *ngIf="selectedItem" class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">
      <div class="form-row two-columns">
        <div class="field">
          <label>Item #</label>
          <input pInputText [value]="selectedItem.itemNumber" readonly class="readonly-field" />
        </div>
        <div class="field">
          <label>Type <span class="required-star">*</span></label>
          <p-select [(ngModel)]="selectedItem.type" [options]="typeOptions"
            optionLabel="label" optionValue="value" placeholder="Select type"
            panelStyleClass="filter-dropdown-panel" appendTo="body" styleClass="w-full" />
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label>Impact <span class="required-star">*</span></label>
          <p-select [(ngModel)]="selectedItem.impact" [options]="impactOptions"
            optionLabel="label" optionValue="value" placeholder="Select impact"
            panelStyleClass="filter-dropdown-panel" appendTo="body" styleClass="w-full" />
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['owner'] && !selectedItem.owner.trim()">
          <label>Owner <span class="required-star">*</span></label>
          <input pInputText [(ngModel)]="selectedItem.owner" placeholder="Enter owner name"
            (blur)="fieldTouched['owner'] = true" />
          <small class="field-error" *ngIf="fieldTouched['owner'] && !selectedItem.owner.trim()">Owner is required</small>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label>Identified Date <span class="required-star">*</span></label>
          <p-datepicker [(ngModel)]="identifiedDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true"
            appendTo="body" [showOnFocus]="false" [autoZIndex]="true" styleClass="w-full" />
        </div>
        <div class="field">
          <label>Target Date</label>
          <p-datepicker [(ngModel)]="targetDate" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true"
            appendTo="body" [showOnFocus]="false" [autoZIndex]="true" styleClass="w-full" />
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label>Date Closed</label>
          <p-datepicker [(ngModel)]="dateClosed" [showIcon]="true" dateFormat="D, M d, yy"
            placeholder="Select date" [showButtonBar]="true"
            appendTo="body" [showOnFocus]="false" [autoZIndex]="true" styleClass="w-full" />
        </div>
        <div class="field">
          <label>Status <span class="required-star">*</span></label>
          <p-select [(ngModel)]="selectedItem.status" [options]="statusOptions"
            optionLabel="label" optionValue="value" placeholder="Select status"
            panelStyleClass="filter-dropdown-panel" appendTo="body" styleClass="w-full" />
        </div>
      </div>

      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['description'] && !selectedItem.description.trim()">
          <label>Description <span class="required-star">*</span></label>
          <textarea pInputText [(ngModel)]="selectedItem.description" rows="3"
            placeholder="Describe the risk / assumption / issue / dependency"
            (blur)="fieldTouched['description'] = true"></textarea>
          <small class="field-error" *ngIf="fieldTouched['description'] && !selectedItem.description.trim()">Description is required</small>
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label>Mitigation Plan</label>
          <textarea pInputText [(ngModel)]="selectedItem.mitigationPlan" rows="2" placeholder="How will this be addressed?"></textarea>
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label>Remark</label>
          <textarea pInputText [(ngModel)]="selectedItem.remark" rows="2" placeholder="Additional context…"></textarea>
        </div>
      </div>
    </div>

    <!-- In-flow footer so the Save button stays visible when this dialog is
         stacked on top of the full-viewport Presales Details modal. -->
    <div class="form-dialog-inline-footer">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="displayItemDialog = false"
        severity="secondary" [outlined]="true" [disabled]="saveInFlight" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveItem()" severity="primary"
        [loading]="saveInFlight"
        [disabled]="saveInFlight || !selectedItem || !selectedItem.description.trim() || !selectedItem.owner.trim()" />
    </div>
  </div>
</p-dialog>
